// Sauce Studios — portfolio fallback data (Sanity is the source of truth in production)

import { normalizePublicId } from "./cloudinary";

/** Normalize string or { publicId, brand, ... } video entries. */
export function getProjectVideos(project) {
  return (project.videos || [])
    .map((item) => {
      if (typeof item === "string") {
        const publicId = normalizePublicId(item);
        return publicId ? { publicId } : null;
      }
      const publicId = normalizePublicId(item?.publicId);
      if (!publicId) return null;
      return {
        publicId,
        brand: (item.brand || "").trim(),
        tagline: (item.tagline || "").trim(),
        industry: (item.industry || "").trim(),
        color: (item.color || "").trim(),
      };
    })
    .filter(Boolean);
}

export function getProjectVideoIds(project) {
  return getProjectVideos(project).map((v) => v.publicId);
}

export function getProjectPhotography(project) {
  return (project.photography || []).map(normalizePublicId).filter(Boolean);
}

export const showreel = {
  title: "One Saucy Year",
  caption: "A year inside our world — the brands, the sets, the late nights.",
  video: "One_Saucy_Year_oyizud",
  cover: "one-suacy-year_xfqrpj",
  heroVideos: {
    web: "Show_Reel_Desktop_dofvd5",
    mobile: "Show_Reel_Vertical_d51zfy",
  },
};

export const projects = [
  {
    slug: "medipulse",
    title: "Medipulse",
    client: "Medipulse",
    industry: "Healthcare",
    services: ["Social Media Content", "Brand Films", "Creative Direction", "Ad Campaigns", "Photography"],
    videos: [
      "Mayank_Singhi_01_Medipulse_tpmvze",
      "Mayank_Singhi_03_Medipulse_qklxvq",
      "Pooja_Sharma_-_Ward_Lady_mcqowe",
    ],
    cover: "4yu1j8ud_KHA_1129_xtjoi1",
    color: "#F4B4C4",
    tagline: "Healthcare, dressed kindly.",
    challenge: "Healthcare is serious. The content doesn't always have to be. Medipulse wanted to humanize their digital presence by moving beyond traditional hospital communication — telling stories of their people, their innovations, and the moments that make their hospital unique.",
    direction: "Finding the stories beyond the stethoscope. We created an engaging content ecosystem built around employee stories, behind-the-scenes moments, educational content, and creative formats that made healthcare more relatable, approachable, and human.",
    photography: [
      "AJM_0475_mj4dhb",
      "AJM_0505_vaimyx",
      "AJM_0615_ricrhi",
      "KHA_1319_wqm3om",
      "KHA_1410_oezpac",
      "KHA_1442_rdgzxd",
    ],
  },
  {
    slug: "jiet-medical-college",
    title: "Jiet Medical College & Hospital",
    client: "Jiet Medical College & Hospital",
    industry: "Healthcare",
    services: ["Brand Films", "Photography", "Creative Direction"],
    videos: [
      "ASMR_JEIT_mp4_dmcyi2",
      "Central_Garden_JMCH_mzbiuu",
      "Dr._Aarti_Kothari_V_kmgj4v",
      "JMCH_TOUR_rl9xad",
    ],
    cover: "JIET-thumbnail_exolyg",
    color: "#F4B4C4",
    tagline: "Medicine, taught and practiced with purpose.",
    challenge: "A medical college and hospital needed a visual identity that felt aspirational to students and reassuring to patients — without the cold stock imagery the category defaults to.",
    direction: "We filmed inside real classrooms, corridors, and wards. We followed residents, faculty, and families — building a story about care as craft, not just credentials.",
    photography: [
      "KHA_1516_rbhxml",
      "KHA_1524_lgafx0",
      "KHA_1546_rvyhcp",
      "KHA_1611_mbk9kx",
      "KHA_1717_a0zxid",
      "KHA_1736_tnusb9",
      "KHA_2016_tqfqf0",
      "KHA_2035_mzbqgs",
      "KHA_8151_i3demn",
      "KHA_8171_xb4bbo",
      "KHA_8205_kxuawz",
      "KHA_8277_zwaogj",
      "KHA_8304_cn7fop",
      "KHA_8367_s9csfq",
      "KHA_8380_zptkqm",
      "KHA_8401_j76tip",
    ],
  },
  {
    slug: "inka-insurance",
    title: "Inka Insurance",
    client: "Inka Insurance",
    industry: "Commercial",
    services: ["Brand Films", "Campaign Strategy", "Creative Direction"],
    videos: [
      "INKA_INSURANCE_cyy9ei",
      "Inka_Insurance_1_qkhbtu",
      "Inka_Insurance_2_lclrfl",
      "Pramod_Reel_1_wl3uap",
      "Pramod_Reel_2_qqvzjf",
      "Pramod_Reel_3_lx7i4z",
      "Puneet_Krishna_Reel_01_xzpz4h",
      "Puneet_Krishna_Reel_03_gcw9ew",
      "shorts_4_m9hfhw",
      "shorts_6_wrrjl6",
    ],
    cover: "INKA_INSURANCE_cyy9ei",
    color: "#F42B29",
    tagline: "Insurance, made human.",
    challenge: "An insurance brand in a category obsessed with fear. Inka wanted to talk about safety like a friend, not a salesperson.",
    direction: "Three connected films — three families, three quiet, ordinary moments. No jargon, no policy numbers, no exclamation marks. Just trust.",
    photography: [

    ],
  },
  {
    slug: "fifteen-ad-diwali",
    title: "15 AD",
    client: "15 AD",
    industry: "Commercial",
    services: ["Films", "Campaign Strategy", "Social Media"],
    videos: [
      "15_AD_DIWALI_wmvamh",
    ],
    cover: "2fh7y5xn_WhatsApp_20Image_202026-06-27_20at_2015.09.08_l1nbpn",
    color: "#FC9603",
    tagline: "A Diwali campaign without a single lamp cliche.",
    challenge: "Stand out in the most cluttered ad week of the Indian calendar — without using golden lamps, smiling families, or stock B-roll.",
    direction: "We swapped sentiment for craft. A single, almost wordless 90-second film about a family that almost didn't gather.",
    photography: [
      "DTI00030_k5aubm",
      "DTI00036_qwbqcx",
      "DTI00037_i3md1l",
      "DTI00045_rpru3x",
      "DTI00055_uglpfn",
      "DTI00098_mbrsej",
      "DTI00120_ststrf",
      "DTI00152_bsxeea",
    ],
  },
  {
    slug: "no-reply",
    title: "No Reply",
    client: "No Reply",
    industry: "Fashion",
    services: ["Films", "Creative Direction"],
    videos: [
      "1_gaccwf",
      "2_jojch3",
      "4_d056kp",
      "6_h5bicc",
      "NO_REPLY_r7fwi6",
      "No_reply_001_ywf7df",
      "TITLE_VIDEO_N_R7_euxueg",
    ],
    cover: "Noreply_Thumbnail_r4lk6f",
    color: "#000000",
    tagline: "A film about the messages we never send.",
    challenge: "An original short film, made on a tiny budget, that needed to compete on craft alone.",
    direction: "Written in a weekend, shot in three days, edited in five. We treated every frame like it might be the only frame anyone remembers.",
    photography: [
      "KHA_0533_f2yvdp",
      "KHA_0583_mofvaa",
      "KHA_0701_wokxyc",
      "KHA_0742_nt7rn4",
      "KHA_0761_z7vzo3",
      "KHA_0840_stuo4i",
      "KHA_0859-2_gkns3r",
      "KHA_0933_jxpfve",
      "KHA_1053_dpa8fp",
      "KHA_1075_rd9bji",
      "KHA_5245_thfpea",
      "KHA_5283_nxwdcr",
      "KHA_5313_ojrf9c",
      "Noreply_Thumbnail_r4lk6f",
    ],
  },
  {
    slug: "paacho-clothing",
    title: "Paacho",
    client: "Paacho",
    industry: "Fashion",
    services: ["Photography", "Films", "Campaign Strategy"],
    videos: [
      "Paacho_Clothing_fvpu0p",
      "Reel_02_pivcsg",
      "Reel_04_qwco80",
      "Reel_05_a7t1bd",
      "Reel_10_pne0fa",
    ],
    cover: "paacho-thumbnail_j8tjae",
    color: "#FF4A01",
    tagline: "Streetwear with a desert soul.",
    challenge: "Position a young Jodhpur clothing label as a credible streetwear name without abandoning its regional identity.",
    direction: "We took the lookbook to the old city's blue lanes. Cast non-models. Let the city wear the brand, instead of the brand wearing the city.",
    photography: [
      "AJM_2909_px3vam",
      "KHA_0012_so2ilv",
      "KHA_0134_osu1ea",
      "KHA_0442_gtwkp0",
      "KHA_0771_wo1prn",
      "KHA_0868_xfxevo",
      "KHA_0906_dhxxav",
      "KHA_1092_dujjtj",
      "KHA_1149_p0rnnt",
      "KHA_9455_o7wxkk",
      "KHA_9529_oybnd1",
      "KHA_9734_xonbjf",
      "KHA_9928_uu3fc8",
    ],
  },
  {
    slug: "loomistry",
    title: "Loomistry",
    client: "Loomistry",
    industry: "Textile",
    services: ["Photography", "Films", "Brand Identity"],
    videos: [
      "IMG_6941_jmfb6r",
      "Loomistry_1_with_music_pqln2w",
      "Loomistry_Logo_Reveal_m8usfc",
      "Loomistry_Manufacturing_4_fqvkbu",
      "Loomistry_Video_01_obijxr",
      "Loomistry_Video_7_zkjmap",
    ],
    cover: "KHA_8574_fxohy3",
    color: "#000000",
    tagline: "Where the loom becomes a language.",
    challenge: "Loomistry handcrafts furniture and textiles in small batches. The campaign needed to honour the maker as much as the made object.",
    direction: "We spent three days inside the workshop. We followed hands more than products. The film opens on calloused fingers, not on price tags.",
    photography: [
      "DSC00152_ba6zzc",
      "DSC00184_gfcojb",
      "DSC08306_s3822z",
      "DSC08353_utdbab",
      "DSC08384_o9d3f4",
      "DSC08393_xrcnxi",
      "DSC08661_mtsutp",
      "DSC08898_y0lp3v",
      "DSC09040_pkzvdy",
      "DSC09259_ywsjjk",
      "DSC09308_lypg37",
      "DSC09998_bcsajn",
      "KHA_8520_zh8csh",
      "KHA_8574_fxohy3",
    ],
  },
  {
    slug: "um-designs",
    title: "U&M Designs",
    client: "U&M Designs",
    industry: "Handicraft",
    services: ["Photography", "Films", "Creative Direction", "Visual Storytelling"],
    videos: [
      "Copy_of_13_March_wxeixy",
      "Copy_of_17_Dec_reel_New_gr9s5t",
      "Copy_of_8th_April_-_Epi_1_-_beginning_of_U_M-_nih4w6",
      "Copy_of_Day_4_u_m_ibvlcg",
      "Copy_of_Feb_13th_Posting_im5yah",
      "Copy_of_Feb_15th_Posting_hktdpi",
      "Copy_of_Rapid_Fire_2_New_khkzip",
    ],
    cover: "3_l9k1mn",
    color: "#000000",
    tagline: "Spaces that feel considered, not decorated.",
    challenge: "U&M Designs needed a portfolio film that communicated taste and restraint — in a market flooded with over-styled interior content.",
    direction: "We shot each space like a still life: natural light, slow pans, no people. Let the materials, proportions, and details do the talking.",
    photography: [
      "3_l9k1mn",
      "ANKIT_20260317_7015.00_21_43_48.Still005_nn0j57",
      "ANKIT_20260317_7015.00_23_27_30.Still002_xo84my",
      "ANKIT_20260317_7015.00_25_24_33.Still010_l60j6h",
      "ANKIT_20260317_7015.00_32_02_48.Still012_1_hxzali",
      "DTC00185_jcyjsi",
      "DTC00240_uqpuah",
      "DTC00274_oyljge",
      "DTC00367_jeziff",
      "DTC01465_xkeiem",
      "DTC01476_wmfngr",
      "DTC01514_k4vpjr",
      "Sequence_01.00_00_19_50.Still002_vdl2yd",
      "Sequence_01.00_01_42_28.Still006_sn4u94",
      "Sequence_01.00_01_55_83.Still026_t3qqeg",
    ],
  },
  {
    slug: "ethnic-clock-makers",
    title: "Ethnic Clock Makers",
    client: "Ethnic Clock Makers",
    industry: "Handicraft",
    services: ["Brand Films", "Photography", "Visual Storytelling"],
    videos: [
      "001_qdzren",
      "02_k3i72n",
      "04_1_wjc89u",
      "05_skmgyc",
      "07_xpsz9p",
      "08_jqzmec",
    ],
    cover: "DTI00351_1_mtn8xe",
    color: "#FC9603",
    tagline: "Time, made by hand.",
    challenge: "A 40-year-old family-run clockmaker had everything except a brand film worth showing to their grandchildren.",
    direction: "We slowed down. Filmed in 4K, edited like a documentary, scored like a meditation. The film opens on a single ticking second.",
    photography: [
      "DTC00102_wgxbmf",
      "DTC00112_l6tugf",
      "DTC00296_zk8mt6",
      "DTC00297_fetjyc",
      "DTI00070_ti2bi2",
      "DTI00072_dwaxix",
      "DTI00103-Edit_haiukc",
      "DTI00165-Edit_akk8qv",
      "DTI00293_zvbj8r",
      "DTI00319_wii4gg",
      "DTI00351_1_mtn8xe",
      "DTI00360_dwsnba",
      "DTI09063_zcmmro",
      "DTI09065_ujamg4",
      "DTI09144_zb2ubo",
      "KHA_9769_hvpvqa",
    ],
  },
  {
    slug: "nlu-taj",
    title: "National Law University",
    client: "National Law University · Taj Hotels",
    industry: "Events",
    services: ["Films", "Photography", "Creative Direction"],
    videos: [
      "NLUJ_-_Reel_01_qoduhe",
      "NLUJ_-_Reel_02_jfmpfv",
      "NLUJ_-_Reel_03_o7mkbv",
      "NLUJ_-_Reel_04_hpbhbo",
      "NLUJ_-_Reel_05_ltajnp",
      "NLU_TAJ_EVENT_yzeqoo",
    ],
    cover: "NLU_TAJ_EVENT_yzeqoo",
    color: "#FF4A01",
    tagline: "Black ties, golden hour.",
    challenge: "A flagship convocation at the Taj that demanded coverage worthy of both institutions — legal heritage and luxury hospitality.",
    direction: "We treated it like a film festival, not a corporate gig. Two cameras, three lenses, one editor in the basement working on a cut by 3 a.m.",
    photography: [

    ],
  },
  {
    slug: "casablanca",
    title: "Casablanca",
    client: "Casablanca",
    industry: "F&B",
    services: ["Photography", "Creative Direction"],
    videos: [
      "Casablanca_pb9wuh",
    ],
    cover: "KHA_7820_d0oogc",
    color: "#F42B29",
    tagline: "A film noir for a quiet rebellion.",
    challenge: "A fashion drop that wanted to feel like a single, perfect cinematic moment — not a campaign.",
    direction: "One night. One alleyway. One actress. We shot it like a 90-second short and called it done.",
    photography: [
      "KHA_7798_w4xohg",
      "KHA_7820_d0oogc",
      "KHA_7824_jx7nga",
    ],
  },
  {
    slug: "bottom-and-bites",
    title: "Bottom & Bites",
    client: "Bottom & Bites",
    industry: "F&B",
    services: ["Films", "Photography", "Social Media"],
    videos: [
      "Bottom_Bites_1_kkfam9",
      "Bottom_Bites_2_v5szqc",
      "Bottom_Bites_ojh0p0",
    ],
    cover: "bottom-bites-thumbnail_kea9qk",
    color: "#FC9603",
    tagline: "Food, but with a pulse.",
    challenge: "Move Bottom & Bites away from the same flat, top-down food photography everyone else was shooting, and into a tactile, painterly visual language.",
    direction: "Natural light only. Hand-built sets. Dishes treated like still-life compositions — closer to a Dutch master than a delivery app.",
    photography: [
      "_DSC0011_essvdu",
      "_DSC0060_1_sjpxf2",
      "_DSC0072_pa9xxo",
      "_DSC0109_tcvy0v",
      "_DSC0118_hadjyi",
      "_DSC9975_traru5",
      "_DSC9997_rfkydt",
    ],
  },
  {
    slug: "ai-generative-content",
    title: "AI Generative Content",
    client: "Sauce Studios",
    industry: "Commercial",
    services: ["AI Generative Content", "Films"],
    videos: [
      "Copy_of_1_March_sdopna",
      "Copy_of_U_M_Chairs_Reel_01_blbmav",
      "U_M_Chair_New_01RE_EDIT_neices",
      "U_M_Chairs_Reel_02_zvkihk",
      "U_M_Chairs_Reel_04_nvf1tp",
      "U_M_Chairs_Reel_05_amlorh",
      "U_M_Chairs_Reel_09_rrgdo5",
      "U_M_Chairs_Reel_10_unep9o",
    ],
    cover: "1_c83frl",
    color: "#FF4A01",
    tagline: "Imagination, rendered at speed.",
    challenge: "Explore how AI-generated imagery and motion could extend a studio's creative range — without sacrificing taste, craft, or brand integrity.",
    direction: "We treated generative tools like another lens in the kit: moodboards, motion tests, campaign concepts, and finished assets — always guided by human art direction.",
    photography: [
      "1_c83frl",
      "1_el5kyd",
      "2_wqdjjo",
    ],
  },
  {
    slug: "extra-sauce",
    title: "Extra Sauce",
    client: "Sauce Studios",
    industry: "Extra Sauce",
    services: ["Films", "Photography", "Creative Direction", "Editing Pod"],
    hideOverview: true,
    videos: [
      {
        publicId: "Chetak_Dealership_mrbiju",
        brand: "Chetak",
        tagline: "Dealership, framed with intent.",
        industry: "Commercial",
        color: "#F42B29",
      },
      {
        publicId: "IMG_2369_licsme",
        brand: "Extra Sauce",
        tagline: "A cut that deserved its own frame.",
        industry: "Extra Sauce",
        color: "#F42B29",
      },
      {
        publicId: "PETIT_PARIS_iw01aa",
        brand: "Petit Paris",
        tagline: "An afternoon with a Parisian heart.",
        industry: "F&B",
        color: "#F4B4C4",
      },
      {
        publicId: "Sauce_Editng_Pod_Video_Final_ohicrn",
        brand: "Editing Pod",
        tagline: "You shoot — we handle the cuts.",
        industry: "Extra Sauce",
        color: "#FF4A01",
      },
    ],
    cover: "KHA_0858_bwljgd",
    color: "#F42B29",
    tagline: "The work that didn't fit a brief — but deserved a frame.",
    photography: [
      "KHA_0858_bwljgd",
      "KHA_0877_ejrjts",
      "KHA_0893-Enhanced-NR_bccnim",
      "KHA_0932_m7r8hc",
      "KHA_0962_artucq",
      "KHA_1020_mlinja",
      "KHA_1069_wjlew6",
      "KHA_7712_nsrh3j",
      "KHA_7737_ld72l0",
      "KHA_7749_lff8mf",
      "KHA_8139_l6ltna",
      "KHA_8359_vrww0l",
      "KHA_8363_j7hkjh",
      "KHA_8364_fhsxeh",
      "KHA_8441-Edit_t4xang",
      "KHA_8460_bom5m7",
      "KHA_8473-Edit_x8kz7f",
      "KHA_8477_fbaqe4",
    ],
  },
];

export const services = [
  { n: "01", name: "Photography", description: "Editorial, fashion, product, hospitality." },
  { n: "02", name: "Films", description: "Brand films, campaign films, documentary." },
  { n: "03", name: "Creative Direction", description: "Concept, art direction, casting, set." },
  { n: "04", name: "Campaign Strategy", description: "Story, message, channel, narrative arc." },
  { n: "05", name: "Social Media", description: "Always-on content, calendars, lookbooks." },
  { n: "06", name: "Product Launches", description: "From teaser to release, end-to-end." },
  { n: "07", name: "Visual Storytelling", description: "When a brand needs more than a logo." },
  { n: "08", name: "Podcast Production", description: "Recording, editing, mastering, publishing." },
  { n: "09", name: "AI Generative Content", description: "AI imagery, motion, concepts, and campaigns." },
  { n: "10", name: "Editing Pod", description: "You shoot, we handle the Edits." },
];

export const testimonials = [
  {
    quote: "Working with Sauce Studios has been a seamless experience. Their team understands the brand, delivers high-quality creatives consistently, and is always proactive with ideas. The attention to detail and execution have genuinely elevated our marketing!",
    author: "Founder, Loomistry",
  },
  {
    quote: "To sauce up your content you need to be here. Everything about Sauce Studios is perfect. From strategising to execution they have it covered. Corners, utilisation of spaces and equipment is just perfect. You need to come here and get your work done to see the output. No one else does it like Sauce Studios.",
    author: "Founder, No Reply",
  },
];

export const clients = [
  "No Reply", "Paacho", "Sankeshwar Oil", "Loomistry", "Ethnic Clock Makers", "Casablanca",
  "Homeguru", "Medipulse Hospital", "Jiet Medical College & Hospital", "Inka Insurance", "U&M",
  "National Law University Jodhpur", "15 AD", "Priyanka's Yoga Studio", "Petit Paris", "Bottom & Bites",
];

export const processSteps = [
  { n: "01", name: "Discover", text: "We listen first. We dig into your business, your audience, your obsession." },
  { n: "02", name: "Imagine", text: "We scribble, mood, argue, refine. We bring a point of view, not a template." },
  { n: "03", name: "Create", text: "We build sets, light scenes, write briefs, edit frames. Real hands, real craft." },
  { n: "04", name: "Refine", text: "We obsess over the last 5%. Because the last 5% is the brand." },
  { n: "05", name: "Deliver", text: "Final assets, rollout plan, and a campaign you'll be proud to share." },
];
